import { render, staticRenderFns } from "./Vlog.vue?vue&type=template&id=442313de&scoped=true&"
import script from "./Vlog.vue?vue&type=script&lang=js&"
export * from "./Vlog.vue?vue&type=script&lang=js&"
import style0 from "./Vlog.vue?vue&type=style&index=0&id=442313de&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442313de",
  null
  
)

export default component.exports